import React, { useState } from 'react'
import { Modal, Button, Divider } from 'antd'
import 'antd/dist/reset.css' // Import Ant Design styles
import './Modal.scss'

const ModalCustom = ({
  visible,
  onCancel,
  title,
  children,
  onConfirm,
  footer = null,
  confirmText = 'Xác nhận',
  cancelText = 'Hủy',
  width,
  ...restProps
}) => {
  const [loading, setLoading] = useState(false) // Trạng thái loading cho button xác nhận

  const handleConfirm = async () => {
    setLoading(true) // Bật loading khi bắt đầu gọi API
    setTimeout(async () => {
      try {
        await onConfirm() // Chờ API xử lý thành công
      } finally {
        setLoading(false) // Tắt loading khi API hoàn tất (dù thành công hay thất bại)
      }
    }, 300)
  }

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      centered
      // closable={false}
      // maskClosable={true}
      width={width}
      maskClosable={false}
      footer={
        footer ? null : (
          <>
            <Divider className="modal-divider"></Divider>
            <div className="modal-footer">
              <Button onClick={onCancel} className="btn-cancel">
                {cancelText}
              </Button>
              {onConfirm && (
                <Button
                  loading={loading}
                  type="primary"
                  onClick={handleConfirm}
                  className="btn-confirm"
                >
                  {confirmText}
                </Button>
              )}
            </div>
          </>
        )
      }
      onOk={onConfirm}
      destroyOnClose
      {...restProps}
    >
      <h2 className="modal-title">{title}</h2>
      <Divider className="modal-divider"></Divider>
      <div className="modal-content">{children}</div>
      {footer && footer.length > 0 ? (
        <>
          <Divider className="modal-divider"></Divider>
          <div className="modal-footer">
            {footer.map((footerItem) => footerItem)}
          </div>
        </>
      ) : null}
    </Modal>
  )
}

export default ModalCustom
